<template>
    <div>
        <section class="ai-gen-head">
            <div class="ai-gen-head-container">
                <h1>Your AI &nbsp;course name generator</h1>
                <p>If you keep naming your courses “Topic 101”, we will cry for you.
                    <br>
                    Instead, give us a few hints, and we will get you names that get clicked and are marketable.
                </p>

                <form @submit.prevent="submitForm" class="ai-form" id="name-generator-form">
                    <div class="ai-form-row">
                        <div class="ai-form-group">
                            <label for="student">Target audience</label>
                            <div class="ai-form-group-input">
                                <img :src="`${m_cloud_url()}uteach/assets/ai-pencil.svg`" alt="Target audience" width="20" height="21">
                                <input type="text" id="target_audience" placeholder="Student" value="" name="target_audience" class="ai-form-control"
                                       v-model="form.target_audience"
                                >
                            </div>
                            <span v-if="errors.target_audience" class="invalid-feedback d-block mt-2" style="color: red;">
                                {{ errors.target_audience[0] }}
                            </span>
                        </div>

                        <div class="ai-form-dropdown">
                                         <p>Course level</p>

                            <button type="button"  class="level-dropdown-toggle">
                                <img :src="`${m_cloud_url()}uteach/assets/ai-pencil.svg`" alt="Course level" width="20" height="21">
                                <span :class="{ 'placeholder': !selectedLevelValue }" id="selected_level">
                                    {{ selectedLevelValue ? selectedLevelLabel : 'Select the course level' }}
                                </span>
                                <span class="menu-arrow"></span>
                            </button>
                            <div class="level-dropdown">
                                <button
                                    v-for="option in levelOptions"
                                    :key="option.value"
                                    :value="option.value"
                                    type="button"
                                    @click="selectOption(option)"
                                >
                                    {{ option.label }}
                                </button>
                            </div>
                        </div>

                        <span v-if="errors.course_level" class="invalid-feedback d-block mt-2" style="color: red;">
                            {{ errors.course_level[0] }}
                        </span>
                    </div>

                    <div class="ai-form-item">
                        <div class="ai-form-group">
                            <label for="about">What is your course about?</label>
                            <div class="ai-form-group-input">
                                <img :src="`${m_cloud_url()}uteach/assets/ai-pencil.svg`" alt="course about" width="20" height="21">
                                <textarea v-model="form.description" name="description" id="description" cols="" rows="" class="ai-form-control captcha-init-item"></textarea>
                            </div>
                            <span v-if="errors.description" class="invalid-feedback d-block mt-2" style="color: red;">
                              {{ errors.description[0] }}
                            </span>
                        </div>
                    </div>

                    <div class="ai-form-item">
                        <button type="submit" class="btn-gradient">
                            <img :src="`${m_cloud_url()}uteach/assets/ai-regenerate-btn.svg`" alt="Generate" width="27" height="27">
                            <span>Generate</span>
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            showModal: false,
            responseData: [],
            form: {
                target_audience: this.step1RequestData?.target_audience || '',
                course_level: this.step1RequestData?.course_level || '',
                description: this.step1RequestData?.description || '',
            },
            errors: {},

            dropdownOpen: false,
            selectedLevelValue: this.step1RequestData?.course_level ||'',
            selectedLevelLabel: 'Select the course level',
            levelOptions: [
                { value: 'beginner', label: 'Beginner' },
                { value: 'intermediate', label: 'Intermediate' },
                { value: 'advanced', label: 'Advanced' }
            ]
        };
    },
    computed: {
        ...mapGetters(['step1RequestData'])
    },
    methods: {
        ...mapActions(['saveNamesResponseData', 'saveStep1RequestData', 'changeStep', 'clearStorageData']),
        async submitForm() {
            const startTime = Date.now();
            $('.ai-loader').addClass('show');

            const form = document.getElementById('name-generator-form');

            if (form.querySelector('.recaptcha_field') || typeof grecaptcha === 'undefined') {
                this.sendRequest(startTime);

            } else {
                grecaptcha.ready(() => {
                    grecaptcha.execute(window.recaptcha_site_key, {action: 'courseNameGenerator'}).then(token => {
                        if (!form.querySelector('.recaptcha_field')) {
                            const recaptchaField = document.createElement('input');
                            recaptchaField.type = 'hidden';
                            recaptchaField.name = 'g-recaptcha-response';
                            recaptchaField.value = token;
                            recaptchaField.classList.add('recaptcha_field');

                            form.appendChild(recaptchaField);
                        }

                        this.form['g-recaptcha-response'] = token;

                        this.sendRequest(startTime);

                    });
                });
            }

        },

        sendRequest(startTime) {
            axios.post('/idea-generator/prompt/names', {
                ...this.form,
            })
                .then(res => {
                    if (res.data.success) {
                        this.saveStep1RequestData(this.form);
                        this.saveNamesResponseData(res.data.results);
                        const elapsedTime = Date.now() - startTime;
                        const remainingTime = Math.max(4000 - elapsedTime, 0);

                        setTimeout(() => {
                            this.changeStep(2);
                            $('.ai-loader').removeClass('show');
                        }, remainingTime);
                    } else {
                        $('.ai-loader').removeClass('show');
                        toastr.danger("Something went wrong, please try again later");
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data.errors) {
                        this.errors = error.response.data.errors;
                    }
                    $('.ai-loader').removeClass('show');
                });
        },

        selectOption(option) {
            this.selectedLevelValue = option.value;
            this.selectedLevelLabel = option.label;
        },


        getLabelForLevel(value) {
            const option = this.levelOptions.find(opt => opt.value === value);
            return option ? option.label : 'Choose the course level';
        },
    },

    mounted() {
        this.clearStorageData();

        $('.level-dropdown-toggle').click(function () {
            if ($(this).hasClass( "dropdown-toggle-open")) {
                $(this).next('.level-dropdown').slideUp();
                $(this).removeClass( "dropdown-toggle-open");
            } else {
                $(this).next('.level-dropdown').slideDown();
                $(this).addClass( "dropdown-toggle-open");
            }
        });

        $(document).click(function (e) {
            let target = e.target;
            if (!$(target).is('.level-dropdown-toggle') && !$(target).parents().is('.level-dropdown-toggle')) {
                $('.level-dropdown').slideUp();
                $('.level-dropdown-toggle').removeClass( "dropdown-toggle-open");
            }
        });

        this.selectedLevelValue = this.step1RequestData?.course_level || '';
        this.selectedLevelLabel = this.getLabelForLevel(this.selectedLevelValue);


        if(this.step1RequestData) {
            this.form.target_audience = this.step1RequestData.target_audience || '';
            this.form.course_level = this.step1RequestData.course_level || '';
            this.form.description = this.step1RequestData.description || '';

            this.selectedLevelValue = this.step1RequestData.course_level || '';
            this.selectedLevelLabel = this.getLabelForLevel(this.step1RequestData.course_level);
        }
    },
};
</script>


<style scoped>

.level-dropdown-toggle span:not(.placeholder) {
    color: black;
}
</style>
